import DisplayWrapper from "@/components/wrappers/DisplayWrapper";
import { useFilterSearchParams, useUpdateFilterSearchParams } from "@/utils/hooksUtils";
import { Card } from "antd";
import { COMMON_AGENT_FILTER_SEARCH_PARAMS } from "../../agent/api";
import { AgentStatus } from "../../agent/enums";
import { useCurrentAgentAccount } from "../../auth/hooks";
import { DEFAULT_SLOVENIA_COMPETITION_QUERY_PARAMS } from "../api";
import { SloveniaCompetitionFilter } from "../components/SloveniaCompetitionFilter";
import { SloveniaCompetitionTable } from "../components/tables/SloveniaCompetitionTable";
import { SloveniaCompetitionResultFilterPageRequest } from "../types";

export const SloveniaCompetitionContainer = () => {
  const agentUserAccount = useCurrentAgentAccount();

  const searchParams = useFilterSearchParams<SloveniaCompetitionResultFilterPageRequest>({
    params: ["orderBy", "orderDirections", ...COMMON_AGENT_FILTER_SEARCH_PARAMS],
    defaultQueryParamsObject: DEFAULT_SLOVENIA_COMPETITION_QUERY_PARAMS,
  });

  const updateSearchParams = useUpdateFilterSearchParams<SloveniaCompetitionResultFilterPageRequest>(
    DEFAULT_SLOVENIA_COMPETITION_QUERY_PARAMS,
  );

  return (
    <DisplayWrapper itemLoaded={true} isError={agentUserAccount?.agent.status !== AgentStatus.BROKER_WITH_CONTRACT}>
      <SloveniaCompetitionFilter searchParams={searchParams} updateSearchParams={updateSearchParams} />

      <Card className="card-box">
        <SloveniaCompetitionTable searchParams={searchParams} updateSearchParams={updateSearchParams} />
      </Card>
    </DisplayWrapper>
  );
};
